import { useState } from "react";
import emailjs from "emailjs-com";
import "./contact.css";

function Contact() {
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [message, setMessage] = useState("");
  const [errorMessage, setErrorMessage] = useState("");
  const [submittedMessage, setSubmittedMessage] = useState("");
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);

    // ✅ Access environment variables (make sure they are in .env)
    const serviceID = process.env.REACT_APP_EMAILJS_SERVICE_ID;
    const templateID = process.env.REACT_APP_EMAILJS_TEMPLATE_ID;
    const publicKey = process.env.REACT_APP_EMAILJS_PUBLIC_KEY;
    console.log(serviceID, templateID, publicKey);

    const templateParams = {
      from_name: name.trim(),
      from_email: email.trim(),
      message: message.trim(),
    };

    try {
      const response = await emailjs.send(
        serviceID,
        templateID,
        templateParams,
        publicKey
      );
      console.log("Email successfully sent!", response.status, response.text);
      setSubmittedMessage("Form Submitted Successfully");
      setErrorMessage("");
    } catch (error) {
      console.error("Failed to send email:", error);
      setErrorMessage("Failed to Submit Form");
      setSubmittedMessage("");
    }

    setName("");
    setEmail("");
    setMessage("");
    setIsSubmitting(false);

    setTimeout(() => {
      setSubmittedMessage("");
      setErrorMessage("");
    }, 5000);
  };

  return (
    <div className="form-container">
      <h2>Contact Us</h2>
      <h3>Let's bring your dream home to life</h3>
      <p>
        Reach out to start your custom build journey, and we’ll guide you
        through every step — from initial ideas to the final touches.
      </p>
      <div className="form-section">
        <div className="form-image">
          <img src="/form2.webp" alt="form-image" loading="eager" />
        </div>
        <div className="form">
          <form onSubmit={handleSubmit}>
            <div className="input-container">
              <label htmlFor="name">Name</label>
              <input
                type="text"
                id="name"
                onChange={(e) => setName(e.target.value)}
                value={name}
                required
              />
            </div>

            <div className="input-container">
              <label htmlFor="email">Email</label>
              <input
                type="email"
                id="email"
                onChange={(e) => setEmail(e.target.value)}
                value={email}
                required
              />
            </div>

            <div className="input-container">
              <label htmlFor="message">Message</label>
              <textarea
                name="message"
                rows={4}
                cols={40}
                className="text-area"
                onChange={(e) => setMessage(e.target.value)}
                value={message}
                required
              />
            </div>

            {submittedMessage && (
              <p className="successMessage">{submittedMessage}</p>
            )}
            {errorMessage && <p className="errorMessage">{errorMessage}</p>}

            <button
              type="submit"
              className="submit-btn"
              disabled={isSubmitting}
            >
              {isSubmitting ? "Sending..." : "Submit"}
            </button>
          </form>
        </div>
      </div>
    </div>
  );
}

export default Contact;
